import React from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { eventTypeIds } from "../../../constants";
var tKey = "wrappers.NotificationToastsDecorator.impl.InvestmentAccountRelatedNotificationToast";
function InvestmentAccountRelatedNotificationToast(props) {
  var notificationId = props.notificationId,
    eventTypeId = props.eventTypeId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var notification = useSelector(function (state) {
    return state.entities.notifications.byId[notificationId];
  });
  var investmentAccountId = notification.event.objects[0].objectId;
  var investmentAccount = useSelector(function (state) {
    return state.entities.investmentAccounts.byId[investmentAccountId];
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, eventTypeId === eventTypeIds.INVESTMENTACCOUNT_CREATED && t("".concat(tKey, ".header_created")), eventTypeId === eventTypeIds.INVESTMENTACCOUNT_ENABLED && t("".concat(tKey, ".header_enabled")), "\xA0\xB7\xA0", moment(notification.createdAt).fromNow(true)), /*#__PURE__*/React.createElement("div", null, eventTypeId === eventTypeIds.INVESTMENTACCOUNT_CREATED && /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".body_created"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    },
    values: {
      brokerName: investmentAccount.broker.name
    }
  }), eventTypeId === eventTypeIds.INVESTMENTACCOUNT_ENABLED && /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".body_enabled"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null),
      lnk: /*#__PURE__*/React.createElement(Link, {
        to: "/pending-deposits"
      })
    },
    values: {
      brokerName: investmentAccount.broker.name
    }
  })));
}
export default InvestmentAccountRelatedNotificationToast;
InvestmentAccountRelatedNotificationToast.propTypes = {
  notificationId: PropTypes.number.isRequired,
  eventTypeId: PropTypes.string.isRequired
};